export enum StatusPromocaoScanntechEnum {
  Aceito = 1,
  Rejeitado = 2,
  Pendente = 3,
}
